import { CustomCreateProposalMutationVariables } from "generated/graphql";
import useCustomCreateProposal from "hooks/proposals/useCustomCreateProposal";
import { forwardRef, useCallback, useImperativeHandle, useRef } from "react";
import { useLocation, useNavigate } from "react-router";
import { getRoute } from "utils/routing";
import CreateProposalForm, { CreateProposalFormHandle } from "./forms/CreateProposalForm";

const CreateProposal = forwardRef<CreateProposalFormHandle, { companyId?: string }>(
  function CreateProposal({ companyId }, ref) {
    const navigate = useNavigate();
    const location = useLocation();
    const formRef = useRef<CreateProposalFormHandle>(null);
    const isTourActiveRef = useRef(!!(location.state as { startTour?: boolean })?.startTour);

    useImperativeHandle(
      ref,
      () => ({
        replay: () => {
          isTourActiveRef.current = true;
          formRef.current?.replay();
        },
      }),
      []
    );

    const [customCreateProposal, { isSuccess, getData }] = useCustomCreateProposal();

    const handleSubmitCreateProposal = useCallback(
      async (values: CustomCreateProposalMutationVariables) => {
        const result = await customCreateProposal({ variables: values });
        const success = isSuccess(result.data);
        const data = getData(result);

        if (success) {
          navigate(getRoute("proposals.draft", [["proposalId", data.id]]), {
            state: isTourActiveRef.current ? { startTour: true } : undefined,
          });
        }

        return { success, data };
      },
      []
    );

    return (
      <div>
        <CreateProposalForm
          ref={formRef}
          onSubmit={handleSubmitCreateProposal}
          companyInitialId={companyId}
        />
      </div>
    );
  }
);

export default CreateProposal;
